export const countries: Country.Object[] = [
  {
    name: 'Afghanistan',
    code: 'AF',
    available: false
  },
  {
    name: 'Åland Islands',
    code: 'AX',
    available: false
  },
  {
    name: 'Albania',
    code: 'AL',
    available: false
  },
  {
    name: 'Algeria',
    code: 'DZ',
    available: false
  },
  {
    name: 'American Samoa',
    code: 'AS',
    available: false
  },
  {
    name: 'AndorrA',
    code: 'AD',
    available: false
  },
  {
    name: 'Angola',
    code: 'AO',
    available: false
  },
  {
    name: 'Anguilla',
    code: 'AI',
    available: false
  },
  {
    name: 'Antarctica',
    code: 'AQ',
    available: false
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
    available: false
  },
  {
    name: 'Argentina',
    code: 'AR',
    available: false
  },
  {
    name: 'Armenia',
    code: 'AM',
    available: false
  },
  {
    name: 'Aruba',
    code: 'AW',
    available: false
  },
  {
    name: 'Australia',
    code: 'AU',
    available: false
  },
  {
    name: 'Austria',
    code: 'AT',
    available: false
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
    available: false
  },
  {
    name: 'Bahamas',
    code: 'BS',
    available: false
  },
  {
    name: 'Bahrain',
    code: 'BH',
    available: false
  },
  {
    name: 'Bangladesh',
    code: 'BD',
    available: false
  },
  {
    name: 'Barbados',
    code: 'BB',
    available: false
  },
  {
    name: 'Belarus',
    code: 'BY',
    available: false
  },
  {
    name: 'Belgium',
    code: 'BE',
    available: false
  },
  {
    name: 'Belize',
    code: 'BZ',
    available: false
  },
  {
    name: 'Benin',
    code: 'BJ',
    available: false
  },
  {
    name: 'Bermuda',
    code: 'BM',
    available: false
  },
  {
    name: 'Bhutan',
    code: 'BT',
    available: false
  },
  {
    name: 'Bolivia',
    code: 'BO',
    available: false
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    available: false
  },
  {
    name: 'Botswana',
    code: 'BW',
    available: false
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
    available: false
  },
  {
    name: 'Brazil',
    code: 'BR',
    available: false
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    available: false
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
    available: false
  },
  {
    name: 'Bulgaria',
    code: 'BG',
    available: false
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
    available: false
  },
  {
    name: 'Burundi',
    code: 'BI',
    available: false
  },
  {
    name: 'Cambodia',
    code: 'KH',
    available: false
  },
  {
    name: 'Cameroon',
    code: 'CM',
    available: false
  },
  {
    name: 'Canada',
    code: 'CA',
    available: false
  },
  {
    name: 'Cape Verde',
    code: 'CV',
    available: false
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
    available: false
  },
  {
    name: 'Central African Republic',
    code: 'CF',
    available: false
  },
  {
    name: 'Chad',
    code: 'TD',
    available: false
  },
  {
    name: 'Chile',
    code: 'CL',
    available: false
  },
  {
    name: 'China',
    code: 'CN',
    available: false
  },
  {
    name: 'Christmas Island',
    code: 'CX',
    available: false
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    available: false
  },
  {
    name: 'Colombia',
    code: 'CO',
    available: false
  },
  {
    name: 'Comoros',
    code: 'KM',
    available: false
  },
  {
    name: 'Congo',
    code: 'CG',
    available: false
  },
  {
    name: 'Congo, The Democratic Republic of the',
    code: 'CD',
    available: false
  },
  {
    name: 'Cook Islands',
    code: 'CK',
    available: false
  },
  {
    name: 'Costa Rica',
    code: 'CR',
    available: false
  },
  {
    name: 'Cote D"Ivoire',
    code: 'CI',
    available: false
  },
  {
    name: 'Croatia',
    code: 'HR',
    available: false
  },
  {
    name: 'Cuba',
    code: 'CU',
    available: false
  },
  {
    name: 'Cyprus',
    code: 'CY',
    available: false
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
    available: false
  },
  {
    name: 'Denmark',
    code: 'DK',
    available: false
  },
  {
    name: 'Djibouti',
    code: 'DJ',
    available: false
  },
  {
    name: 'Dominica',
    code: 'DM',
    available: false
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
    available: false
  },
  {
    name: 'Ecuador',
    code: 'EC',
    available: false
  },
  {
    name: 'Egypt',
    code: 'EG',
    available: false
  },
  {
    name: 'El Salvador',
    code: 'SV',
    available: false
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
    available: false
  },
  {
    name: 'Eritrea',
    code: 'ER',
    available: false
  },
  {
    name: 'Estonia',
    code: 'EE',
    available: false
  },
  {
    name: 'Ethiopia',
    code: 'ET',
    available: false
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    available: false
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
    available: false
  },
  {
    name: 'Fiji',
    code: 'FJ',
    available: false
  },
  {
    name: 'Finland',
    code: 'FI',
    available: false
  },
  {
    name: 'France',
    code: 'FR',
    available: false
  },
  {
    name: 'French Guiana',
    code: 'GF',
    available: false
  },
  {
    name: 'French Polynesia',
    code: 'PF',
    available: false
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
    available: false
  },
  {
    name: 'Gabon',
    code: 'GA',
    available: false
  },
  {
    name: 'Gambia',
    code: 'GM',
    available: false
  },
  {
    name: 'Georgia',
    code: 'GE',
    available: false
  },
  {
    name: 'Germany',
    code: 'DE',
    available: false
  },
  {
    name: 'Ghana',
    code: 'GH',
    available: false
  },
  {
    name: 'Gibraltar',
    code: 'GI',
    available: false
  },
  {
    name: 'Greece',
    code: 'GR',
    available: false
  },
  {
    name: 'Greenland',
    code: 'GL',
    available: false
  },
  {
    name: 'Grenada',
    code: 'GD',
    available: false
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
    available: false
  },
  {
    name: 'Guam',
    code: 'GU',
    available: false
  },
  {
    name: 'Guatemala',
    code: 'GT',
    available: false
  },
  {
    name: 'Guernsey',
    code: 'GG',
    available: false
  },
  {
    name: 'Guinea',
    code: 'GN',
    available: false
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
    available: false
  },
  {
    name: 'Guyana',
    code: 'GY',
    available: false
  },
  {
    name: 'Haiti',
    code: 'HT',
    available: false
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    code: 'HM',
    available: false
  },
  {
    name: 'Holy See (Vatican City State)',
    code: 'VA',
    available: false
  },
  {
    name: 'Honduras',
    code: 'HN',
    available: false
  },
  {
    name: 'Hong Kong',
    code: 'HK',
    available: false
  },
  {
    name: 'Hungary',
    code: 'HU',
    available: false
  },
  {
    name: 'Iceland',
    code: 'IS',
    available: false
  },
  {
    name: 'India',
    code: 'IN',
    available: false
  },
  {
    name: 'Indonesia',
    code: 'ID',
    available: false
  },
  {
    name: 'Iran, Islamic Republic Of',
    code: 'IR',
    available: false
  },
  {
    name: 'Iraq',
    code: 'IQ',
    available: false
  },
  {
    name: 'Ireland',
    code: 'IE',
    available: false
  },
  {
    name: 'Isle of Man',
    code: 'IM',
    available: false
  },
  {
    name: 'Israel',
    code: 'IL',
    available: false
  },
  {
    name: 'Italy',
    code: 'IT',
    available: false
  },
  {
    name: 'Jamaica',
    code: 'JM',
    available: false
  },
  {
    name: 'Japan',
    code: 'JP',
    available: false
  },
  {
    name: 'Jersey',
    code: 'JE',
    available: false
  },
  {
    name: 'Jordan',
    code: 'JO',
    available: false
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
    available: false
  },
  {
    name: 'Kenya',
    code: 'KE',
    available: false
  },
  {
    name: 'Kiribati',
    code: 'KI',
    available: false
  },
  {
    name: 'Korea, Democratic People"S Republic of',
    code: 'KP',
    available: false
  },
  {
    name: 'Korea, Republic of',
    code: 'KR',
    available: false
  },
  {
    name: 'Kuwait',
    code: 'KW',
    available: false
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
    available: false
  },
  {
    name: 'Lao People"S Democratic Republic',
    code: 'LA',
    available: false
  },
  {
    name: 'Latvia',
    code: 'LV',
    available: false
  },
  {
    name: 'Lebanon',
    code: 'LB',
    available: false
  },
  {
    name: 'Lesotho',
    code: 'LS',
    available: false
  },
  {
    name: 'Liberia',
    code: 'LR',
    available: false
  },
  {
    name: 'Libyan Arab Jamahiriya',
    code: 'LY',
    available: false
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
    available: false
  },
  {
    name: 'Lithuania',
    code: 'LT',
    available: false
  },
  {
    name: 'Luxembourg',
    code: 'LU',
    available: false
  },
  {
    name: 'Macao',
    code: 'MO',
    available: false
  },
  {
    name: 'Macedonia, The Former Yugoslav Republic of',
    code: 'MK',
    available: false
  },
  {
    name: 'Madagascar',
    code: 'MG',
    available: false
  },
  {
    name: 'Malawi',
    code: 'MW',
    available: false
  },
  {
    name: 'Malaysia',
    code: 'MY',
    available: false
  },
  {
    name: 'Maldives',
    code: 'MV',
    available: false
  },
  {
    name: 'Mali',
    code: 'ML',
    available: false
  },
  {
    name: 'Malta',
    code: 'MT',
    available: false
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
    available: false
  },
  {
    name: 'Martinique',
    code: 'MQ',
    available: false
  },
  {
    name: 'Mauritania',
    code: 'MR',
    available: false
  },
  {
    name: 'Mauritius',
    code: 'MU',
    available: false
  },
  {
    name: 'Mayotte',
    code: 'YT',
    available: false
  },
  {
    name: 'Mexico',
    code: 'MX',
    available: false
  },
  {
    name: 'Micronesia, Federated States of',
    code: 'FM',
    available: false
  },
  {
    name: 'Moldova, Republic of',
    code: 'MD',
    available: false
  },
  {
    name: 'Monaco',
    code: 'MC',
    available: false
  },
  {
    name: 'Mongolia',
    code: 'MN',
    available: false
  },
  {
    name: 'Montserrat',
    code: 'MS',
    available: false
  },
  {
    name: 'Morocco',
    code: 'MA',
    available: false
  },
  {
    name: 'Mozambique',
    code: 'MZ',
    available: false
  },
  {
    name: 'Myanmar',
    code: 'MM',
    available: false
  },
  {
    name: 'Namibia',
    code: 'NA',
    available: false
  },
  {
    name: 'Nauru',
    code: 'NR',
    available: false
  },
  {
    name: 'Nepal',
    code: 'NP',
    available: false
  },
  {
    name: 'Netherlands',
    code: 'NL',
    available: false
  },
  {
    name: 'Netherlands Antilles',
    code: 'AN',
    available: false
  },
  {
    name: 'New Caledonia',
    code: 'NC',
    available: false
  },
  {
    name: 'New Zealand',
    code: 'NZ',
    available: false
  },
  {
    name: 'Nicaragua',
    code: 'NI',
    available: false
  },
  {
    name: 'Niger',
    code: 'NE',
    available: false
  },
  {
    name: 'Nigeria',
    code: 'NG',
    available: false
  },
  {
    name: 'Niue',
    code: 'NU',
    available: false
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
    available: false
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
    available: false
  },
  {
    name: 'Norway',
    code: 'NO',
    available: false
  },
  {
    name: 'Oman',
    code: 'OM',
    available: false
  },
  {
    name: 'Pakistan',
    code: 'PK',
    available: false
  },
  {
    name: 'Palau',
    code: 'PW',
    available: false
  },
  {
    name: 'Palestinian Territory, Occupied',
    code: 'PS',
    available: false
  },
  {
    name: 'Panama',
    code: 'PA',
    available: false
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
    available: false
  },
  {
    name: 'Paraguay',
    code: 'PY',
    available: false
  },
  {
    name: 'Peru',
    code: 'PE',
    available: false
  },
  {
    name: 'Philippines',
    code: 'PH',
    available: false
  },
  {
    name: 'Pitcairn',
    code: 'PN',
    available: false
  },
  {
    name: 'Poland',
    code: 'PL',
    available: false
  },
  {
    name: 'Portugal',
    code: 'PT',
    available: false
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
    available: false
  },
  {
    name: 'Qatar',
    code: 'QA',
    available: false
  },
  {
    name: 'Reunion',
    code: 'RE',
    available: false
  },
  {
    name: 'Romania',
    code: 'RO',
    available: false
  },
  {
    name: 'Russian Federation',
    code: 'RU',
    available: false
  },
  {
    name: 'RWANDA',
    code: 'RW',
    available: false
  },
  {
    name: 'Saint Helena',
    code: 'SH',
    available: false
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    available: false
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
    available: false
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
    available: false
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    available: false
  },
  {
    name: 'Samoa',
    code: 'WS',
    available: false
  },
  {
    name: 'San Marino',
    code: 'SM',
    available: false
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
    available: false
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
    available: false
  },
  {
    name: 'Senegal',
    code: 'SN',
    available: false
  },
  {
    name: 'Serbia and Montenegro',
    code: 'CS',
    available: false
  },
  {
    name: 'Seychelles',
    code: 'SC',
    available: false
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
    available: false
  },
  {
    name: 'Singapore',
    code: 'SG',
    available: false
  },
  {
    name: 'Slovakia',
    code: 'SK',
    available: false
  },
  {
    name: 'Slovenia',
    code: 'SI',
    available: false
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
    available: false
  },
  {
    name: 'Somalia',
    code: 'SO',
    available: false
  },
  {
    name: 'South Africa',
    code: 'ZA',
    available: false
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
    available: false
  },
  {
    name: 'Spain',
    code: 'ES',
    available: false
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
    available: false
  },
  {
    name: 'Sudan',
    code: 'SD',
    available: false
  },
  {
    name: 'Suriname',
    code: 'SR',
    available: false
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
    available: false
  },
  {
    name: 'Swaziland',
    code: 'SZ',
    available: false
  },
  {
    name: 'Sweden',
    code: 'SE',
    available: false
  },
  {
    name: 'Switzerland',
    code: 'CH',
    available: false
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
    available: false
  },
  {
    name: 'Taiwan, Province of China',
    code: 'TW',
    available: false
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
    available: false
  },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
    available: false
  },
  {
    name: 'Thailand',
    code: 'TH',
    available: false
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
    available: false
  },
  {
    name: 'Togo',
    code: 'TG',
    available: false
  },
  {
    name: 'Tokelau',
    code: 'TK',
    available: false
  },
  {
    name: 'Tonga',
    code: 'TO',
    available: false
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
    available: false
  },
  {
    name: 'Tunisia',
    code: 'TN',
    available: false
  },
  {
    name: 'Turkey',
    code: 'TR',
    available: false
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
    available: false
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    available: false
  },
  {
    name: 'Tuvalu',
    code: 'TV',
    available: false
  },
  {
    name: 'Uganda',
    code: 'UG',
    available: false
  },
  {
    name: 'Ukraine',
    code: 'UA',
    available: false
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
    available: false
  },
  {
    name: 'United Kingdom',
    code: 'GB',
    available: false
  },
  {
    name: 'United States',
    code: 'US',
    available: true
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
    available: false
  },
  {
    name: 'Uruguay',
    code: 'UY',
    available: false
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
    available: false
  },
  {
    name: 'Vanuatu',
    code: 'VU',
    available: false
  },
  {
    name: 'Venezuela',
    code: 'VE',
    available: false
  },
  {
    name: 'Viet Nam',
    code: 'VN',
    available: false
  },
  {
    name: 'Virgin Islands, British',
    code: 'VG',
    available: false
  },
  {
    name: 'Virgin Islands, U.S.',
    code: 'VI',
    available: false
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
    available: false
  },
  {
    name: 'Western Sahara',
    code: 'EH',
    available: false
  },
  {
    name: 'Yemen',
    code: 'YE',
    available: false
  },
  {
    name: 'Zambia',
    code: 'ZM',
    available: false
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
    available: false
  }
];
